/**
 * STATUS — единый enum статусов операций для бэкенда и фронтенда.
 *
 * Ходит через WS и REST между сервером и клиентом, поэтому источник правды —
 * здесь (@acc/shared). До выноса enum был продублирован в project/src/types/statusType.ts
 * (с NO_ACCESS, без SUCCESS_WITH_ERROR/WARN) и front/src/utils/const.ts
 * (с SUCCESS_WITH_ERROR/WARN, без NO_ACCESS) — значения уже разошлись.
 *
 * Здесь объединены все варианты (union superset):
 *  - ERROR / SUCCESS / IN_PROGRESS / INVALID_COOKIES / INVALID_FILES / INVALID_WAREHOUSE — общие
 *  - SUCCESS_WITH_ERROR — частичный успех (полусиний статус в UI)
 *  - WARN — предупреждение (не ошибка, но внимание нужно)
 *  - NO_ACCESS — нет доступа (бэкенд-only сценарии, напр. истёкший токен раздела WB)
 */
export enum STATUS {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
  SUCCESS_WITH_ERROR = "SUCCESS_WITH_ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  INVALID_COOKIES = "INVALID_COOKIES",
  INVALID_FILES = "INVALID_FILES",
  INVALID_WAREHOUSE = "INVALID_WAREHOUSE",
  WARN = "WARN",
  NO_ACCESS = "NO_ACCESS",
}
